import apiClient from './client';

export async function getImpersonationCandidates() {
  const res = await apiClient.get('/api/v1/admin/auth/impersonate/candidates');
  return res.data;
}

export async function startImpersonation(username) {
  const res = await apiClient.post('/api/v1/admin/auth/impersonate', { username });
  return res.data;
}

export async function stopImpersonation() {
  const res = await apiClient.post('/api/v1/admin/auth/impersonate/stop');
  return res.data;
}